export default __webpack_public_path__ + "static/media/sound.df297522.mp3";